<template>
    <v-card flat>
        <v-system-bar dark color="primary">
            <span v-if="step == 1">Basic Info</span>
            <span v-if="step > 1">Question {{ step - 1 }}</span>
            <v-spacer></v-spacer>
            <span>
                {{ step + "/" + (item ? item.questions.length + 1 : 0) }}
            </span>
        </v-system-bar>
        <div v-if="!completionFlag">
            <v-stepper v-model="step" v-if="item">
                <v-stepper-content step="1">
                    <v-card class="mb-12" flat>
                        <v-form ref="submissionForm">
                            <v-card-text class="justify-center pa-0">
                                <v-img
                                    :src="require('../../assets/tms-logo.png')"
                                    :lazy-src="
                                        require('../../assets/tms-logo.png')
                                    "
                                    class="slicklogin-form-logo mb-2"
                                    height="100px"
                                    contain
                                ></v-img>
                                <div class="slicklogin-form-portalname">
                                    Customer Feedback Form
                                </div>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">First Name</div>
                                <v-text-field
                                    v-model="submission.first_name"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">Last Name</div>
                                <v-text-field
                                    v-model="submission.last_name"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">Phone</div>
                                <v-text-field
                                    v-model="submission.phone"
                                    type="number"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">Email</div>
                                <v-text-field
                                    v-model="submission.email"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">
                                    Age Group
                                </div>
                                <v-radio-group
                                    v-model="submission.age_group"
                                >
                                    <v-radio
                                        v-for="(n, index) in age_group_options"
                                        :key="index"
                                        :label="`${n}`"
                                        :value="4 - index"
                                    ></v-radio>
                                </v-radio-group>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">Are you a Temasek Club member?</div>
                                <v-radio-group
                                    v-model="submission.tms_member"
                                    required
                                    :rules="[(v) => !!v || 'Are you a member?']"
                                >
                                    <v-radio label="Yes" value="True"></v-radio>
                                    <v-radio label="No" value="False"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-form>
                        <v-card-text>
                            <v-alert
                            dense
                            outlined
                            color="darkgrey"
                            >
                            <b>Thank you for visiting Temasek Club. </b><br/><br/>
                            <b>Disclaimer</b><br/>
                            1. I give consent to Temasek Club to collect, use and disclose my personal data for customer research and marketing purposes. <br/><br/>

                            2. The information collected from this survey will be kept strictly confidential.<br/><br/>
                            </v-alert>
                        </v-card-text>
                    </v-card>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="completeBasicInfo"
                            >Continue</v-btn
                        >
                    </v-card-actions>
                </v-stepper-content>
                <v-stepper-content
                    v-for="(question, index) in item.questions"
                    v-bind:key="'c' + index"
                    :step="index + 2"
                >
                    <v-card class="mb-12" flat v-if="step > 1">
                        <v-form ref="questionForm">
                            <v-card-text>
                                <div class="subtitle-1">
                                    {{ question.question }}
                                </div>
                                <v-radio-group
                                    v-model="submission.answers[index].score"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                >
                                    <v-radio
                                        v-for="(n, index) in rating_options"
                                        :key="index"
                                        :label="`${n}`"
                                        :value="4 - index"
                                    ></v-radio>
                                </v-radio-group>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">
                                    Other comments / suggestions (Optional)
                                </div>
                                <v-textarea
                                    v-model="submission.answers[index].feedback"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-textarea>
                            </v-card-text>
                        </v-form>
                    </v-card>
                    <v-card-actions>
                        <v-btn text @click="step = index + 1">Back</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="nextOrComplete(index, question.id)"
                        >
                            {{
                                index == item.questions.length - 1
                                    ? "Complete"
                                    : "Continue"
                            }}</v-btn
                        >
                    </v-card-actions>
                </v-stepper-content>
            </v-stepper>
            <div>
                <survey-modal
                    :dialog="dialog"
                    :text="dialogText"
                    :btnOne="dialogBtnOne"
                    :btnTwo="dialogBtnTwo"
                    @restartOrCont="decide"
                />
            </div>
        </div>
        <div v-else>
            <thank-you @setStep="setStep()" />
        </div>
    </v-card>
</template>

<script>
import ThankYou from "@/components/Thankyou";
import SurveyModal from "@/components/modals/SurveyModal";
export default {
    props: {},
    components: {
        ThankYou,
        SurveyModal,
    },
    data() {
        return {
            modelPath: "feedback-tool/form",
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            item: null,
            loading: false,
            current: 1,
            step: 1,
            age_group_options: ["20 - 30", "31 - 40", "41 - 50", "51 & above"],
            rating_options: ["Strongly Agree", "Agree", "Disagree", "Strongly Disagree"],
            submission: {
                answers: [],
                isCompleted: false,
            },
            formId: 0,
            completionFlag: false,
            dialog: false,
            dialogText: "",
            dialogBtnOne: "",
            dialogBtnTwo: "",
        };
    },
    computed: {},
    created() {
        this.formId = this.$route.params.id;
        this.getItemDetails().then((data) => {
            this.item = data.item;
            this.answersArrayInSubmission();
        });
    },
    watch: {},
    methods: {
        getItemDetails: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/feedback-tool/form/${this.formId}`,
                }).then(function (response) {
                    console.log(response.data);
                    let item = response.data;
                    resolve({
                        item,
                    });
                });
            });
        },
        completeBasicInfo: function () {
            if (this.$refs.submissionForm.validate()) {
                if (localStorage && localStorage[this.submission.email]) {
                    let data = JSON.parse(localStorage[this.submission.email]);
                    if (data.isCompleted) {
                        this.dialog = true;
                        this.dialogText =
                            "You already have filled the survey. Do You want to refill ?";
                        this.dialogBtnOne = "Yes";
                        this.dialogBtnTwo = "No";
                    } else {
                        this.dialog = true;
                        this.dialogText = "Do You want to Continue or Restart";
                        this.dialogBtnOne = "Restart";
                        this.dialogBtnTwo = "Continue";
                    }
                } else {
                    this.step = 2;
                }
                this.commonFill();
            }
            // this.completionFlag = true;
        },

        commonFill() {
            this.submission.event_id = this.item.event_id;
            this.submission.form_id = Number(this.formId);
            localStorage.setItem(
                this.submission.email,
                JSON.stringify(this.submission)
            );
        },

        answersArrayInSubmission() {
            this.submission.answers = [];
            this.item.questions.forEach(() => {
                this.submission.answers.push({});
            });
        },

        nextOrComplete: function (index, qId) {
            this.submission.answers[index].question_id = qId;
            this.submission.answers[index].event_id = this.submission.event_id;
            this.submission.answers[index].form_id = this.submission.form_id;
            if (index != this.item.questions.length - 1) {
                localStorage.setItem(
                    this.submission.email,
                    JSON.stringify(this.submission)
                );
                this.step = this.$refs.questionForm[index].validate()
                    ? index + 3
                    : this.step;
            } else {
                if (this.$refs.questionForm[index].validate()) {
                    this.save();
                    this.submission.isCompleted = true;
                    localStorage.setItem(
                        this.submission.email,
                        JSON.stringify(this.submission)
                    );
                    this.completionFlag = true;
                }
            }
        },
        save() {
            this.savePublicSubmission().then((data) => {
                this.completionFlag = true;
                this.answersArrayInSubmission();
            });
        },

        savePublicSubmission() {
            return new Promise((resolve) => {
                this.$http({
                    method: "post",
                    url: `/feedback-tool/submission/`,
                    data: this.submission,
                }).then(function (response) {
                    let item = response.data;
                    resolve({
                        item,
                    });
                });
            });
        },

        clearLocalStorage() {
            for (var i = 0; i < localStorage.length; i++) {
                let key = localStorage.key(i);
                if (key != "user-refresh" && key != "user-token") {
                    localStorage.removeItem(key);
                }
            }
        },

        decide(flag, sFlag) {
            if (flag) {
                this.clearLocalStorage();
                this.answersArrayInSubmission();
                this.commonFill();
            }
            if (this.dialogBtnTwo == "No" && sFlag == "no") {
                this.step = 1;
                this.completionFlag = true;
            } else {
                this.step = 2;
            }
            this.dialog = false;
        },

        setStep() {
            this.step = 1;
            this.submission = {
                answers: [],
                isCompleted: false,
            };
            this.answersArrayInSubmission();
            this.completionFlag = false;
        },
    },
};
</script>

<style>
.slicklogin-login-form {
    margin-top: 150px;
    border-top: 4px solid #a7a284 !important;
}
.slicklogin-form-portalname {
    position: relative;
    top: -10px;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
}
</style>